import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { useAppContext } from '../../context/AppContext.js';
import Tabs from '../../components/Tabs.js';
import IconBudgetCapital from '../../components/icons/IconBudgetCapital.js';
import IconBudgetOperation from '../../components/icons/IconBudgetOperation.js';
import HomeBodyPart1 from './HomeBodyPart1.js';
import HomeBodyPart2 from './HomeBodyPart2.js';
import { getWords } from '../../utils/get-words.js';

const HomeBody = ReactRouterDOM.withRouter(function () {
  const { i18n, setError } = useAppContext();
  const words = getWords(i18n.code);

  return (
    <div>
      <div>
        <Tabs
          tabs={[
            { icon: IconBudgetCapital, label: words.capitals, component: HomeBodyPart1 },
            { icon: IconBudgetOperation, label: words.operations, component: HomeBodyPart2 },
          ]}
        />
      </div>
    </div>
  );
})

export default HomeBody;
